import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { RoleTarget } from '../entities/role-target';


export class RoleTargetRequest extends BaseRequest {
    roleTarget : RoleTarget;
}
